<template>
	<view class="shop">
		<view class="shop_image">
			<image src="@/static/images/Maskgroup@2x.png" mode="widthFix"></image>
		</view>
		<view class="shop_info">
			<view class="top">
				<view class="top_left">
					<text class="top_left_price">29</text>
					<text class="top_left_label">咖豆</text>
				</view>
				<text class="top_right">已兑619份</text>
			</view>
			<text class="title">清澄白河马克杯-节日版定制</text>
		</view>
		<view class="shop_desc">
			<view class="label">商品详情</view>
			<view class="content">富文本</view>
		</view>
		<view class="shop_footer">
			<view class="shop_footer_btn" @click="open">立即兑换</view>
		</view>
		<uni-popup ref="popup" background-color="#fff">
			<view class="popup">
				<view class="popup_title">
					<view class="popup_title_left">
						<image src="@/static/uni.png" mode="widthFix"></image>
						<view class="yi">
							<text>29</text>
							<text>咖豆</text>
						</view>
					</view>
					<uni-icons type="closeempty" size="20" color="#999999" @click="close"></uni-icons>
				</view>
				<view class="popup_xian"></view>
				<scroll-view scroll-y class="popup_list">
					<view class="popup_list_item" v-for="(item, index) in 2" :key="index">
						<view class="label">颜色</view>
						<view class="list">
							<view class="list_item active">白色</view>
							<view class="list_item">黑色</view>
						</view>
					</view>
				</scroll-view>
				<view class="popup_footer">
					<view class="popup_footer_btn" @click="next">下一步</view>
				</view>
			</view>
		</uni-popup>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			open() {
				this.$refs.popup.open('bottom')
			},
			close() {
				this.$refs.popup.close()
			},
			next() {
				uni.navigateTo({
					url: '/pages/confirmOrder/index'
				});
			}
		}
	}
</script>

<style>
	
</style>

<style lang="scss" scoped>
	.shop {
		width: 100%;
		.shop_image {
			width: 100%;
			height: 748rpx;
			image {
				width: 100%;
				height: 100%;
			}
		}
		.shop_info {
			width: 100%;
			box-sizing: border-box;
			padding: 28rpx 32rpx;
			background-color: #ffffff;
			.top {
				display: flex;
				align-items: center;
				justify-content: space-between;
				.top_left {
					display: flex;
					align-items: center;
					.top_left_price {
						font-size: 40rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #D20A0A;
					}
					.top_left_label {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #D20A0A;
					}
				}
				.top_right {
					font-size: 24rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
				}
			}
			.title {
				font-size: 36rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
		}
		.shop_desc {
			width: 100%;
			margin-top: 16rpx;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			.label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.content {
				margin-top: 20rpx;
			}
		}
		.shop_footer {
			padding: 8rpx 56rpx calc(env(safe-area-inset-bottom) + 8rpx) 56rpx;
			background-color: #ffffff;
			width: 100%;
			box-sizing: border-box;
			position: fixed;
			bottom: 0;
			left: 0;
			.shop_footer_btn {
				width: 100%;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
				border-radius: 36rpx 36rpx 36rpx 36rpx;
			}
			
			
		}
		.popup {
			width: 100%;
			padding: 44rpx 32rpx 0 32rpx;
			background-color: #ffffff;
			box-sizing: border-box;
			.popup_title {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				.popup_title_left {
					display: flex;
					align-items: center;
					image {
						width: 128rpx;
						height: 128rpx;
						margin-right: 16rpx;
					}
					.yi {
						display: flex;
						align-items: center;
						text {
							&:first-child {
								font-size: 40rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #D20A0A;
							}
							&:last-child {
								font-size: 28rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #D20A0A;
							}
						}
					}
				}
			}
			.popup_xian { 
				width: 100%;
				height: 2rpx;
				margin: 48rpx 0;
				background-color: #F4F5F4;
			}
			.popup_list {
				width: 100%;
				max-height: 500rpx;
				display: flex; 
				flex-direction: column;
				.popup_list_item {
					display: flex;
					flex-direction: column;
					margin-bottom: 24rpx;
					.label {
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					.list {
						display: flex;
						align-items: center;
						margin-top: 24rpx;
						.active {
							background: rgba(210,10,10,0.08) !important;
							border: 2rpx solid #D20A0A !important;
							font-size: 28rpx;
							font-weight: 500;
							color: #D20A0A;
						}
						.list_item {
							padding: 24rpx 48rpx;
							background: #F5F5F5;
							border-radius: 16rpx;
							margin-right: 26rpx;
							&:last-child {
								margin-right: 0 !important;
							}
						}
					}
				}
			}
			.popup_footer {
				width: 100%;
				padding: 10rpx 24rpx;
				box-sizing: border-box;
				margin-top: 120rpx;
				border-top: 2rpx solid #F4F5F4;
				.popup_footer_btn {
					width: 100%; 
					height: 72rpx;
					line-height: 72rpx;
					text-align: center;
					background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
					border-radius: 36rpx;
					font-size: 32rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #FFFFFF;
				}
			}
		}
	}
</style>